<span *ngIf="!buttonText" class="material-symbols-outlined" id="help-icon" (click)="showHelp()">info</span>

<button *ngIf="buttonText" id="help-button" (click)="showHelp()">{{ buttonText }}</button>
